import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { PHASE } from "../../../routeConfig";
import UnlinkedApplicationAutoApplicableDiscounts from "./applicable-discounts";
import UnlinkedApplicationAutoDownPaymentPage from "./down-payment";
import UnlinkedApplicationAutoDrivers from "./drivers";
import UnlinkedApplicationAutoMilitaryPage from "./military";
import UnlinkedApplicationAutoPaymentPeriod from "./payment-period";
import UnlinkedApplicationAutoPolicyExpiration from "./policy-expiration";
import UnlinkedApplicationAutoPremium from "./premium";
import UnlinkedApplicationAutoReview from "./review";
import UnlinkedApplicationAutoVehicleEdit from "./vehicles/edit";
import UnlinkedApplicationAutoVehicles from "./vehicles";
import UnlinkedApplicationPolicyHolder from "./policy-holder";
export default function UnlinkedApplicationAutoRoutes() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(path, "/policy-holder") },
            React.createElement(UnlinkedApplicationPolicyHolder, null)),
        React.createElement(Route, { exact: true, path: "".concat(path, "/vehicles"), component: UnlinkedApplicationAutoVehicles }),
        React.createElement(Route, { path: "".concat(path, "/vehicles/edit/:vehicleId") },
            React.createElement(UnlinkedApplicationAutoVehicleEdit, null)),
        React.createElement(Route, { path: "".concat(path, "/drivers"), component: UnlinkedApplicationAutoDrivers }),
        React.createElement(Route, { path: "".concat(path, "/applicable-discounts"), component: UnlinkedApplicationAutoApplicableDiscounts }),
        React.createElement(Route, { path: "".concat(path, "/review"), component: UnlinkedApplicationAutoReview }),
        React.createElement(Route, { path: "".concat(path, "/payment-period"), component: UnlinkedApplicationAutoPaymentPeriod }),
        React.createElement(Route, { path: "".concat(path, "/premium"), component: UnlinkedApplicationAutoPremium }),
        React.createElement(Route, { path: "".concat(path, "/down-payment") },
            React.createElement(UnlinkedApplicationAutoDownPaymentPage, null)),
        React.createElement(Route, { path: "".concat(path, "/military") },
            React.createElement(UnlinkedApplicationAutoMilitaryPage, null)),
        React.createElement(Route, { path: PHASE.UNLINKED_APPLICATION_AUTO_POLICY_EXPIRATION },
            React.createElement(UnlinkedApplicationAutoPolicyExpiration, null))));
}
